export default {"src":"/komodo/_next/static/media/footer-arrow-mobile.063e3059.svg","height":9,"width":9,"blurWidth":0,"blurHeight":0};